const SET_EVENT_SUBMISSIONS = (state, payload) => {
  state.selectedEvent = payload.selectedEvent;
  state.selectedOrigin = payload.origin;
  state.currentOrigin.eventSubmissions = payload.eventSubmissions.results.map(
    (i) => i.item
  );

  state.user = payload.user;
};

export default SET_EVENT_SUBMISSIONS;
